// A3 Durchlaufplanung · Client-Spiegel der TS-Utilities aus api/src/lib/prioScore.ts
// Keine SQL-Constants hier — nur die reinen Utilities für Badge/Tooltip.

export type BucketCode = 'feuer' | 'uhr' | 'puffer';

export interface BucketMeta {
  code: BucketCode;
  icon: '🔥' | '⏰' | '✅';
  label: string;
  color: string;
}

export function scoreToBucket(score: number): BucketMeta {
  if (score >= 200) {
    return { code: 'feuer', icon: '🔥', label: 'Heute erledigen', color: 'bg-red-100 text-red-800 border-red-300' };
  }
  if (score >= 80) {
    return { code: 'uhr', icon: '⏰', label: 'Morgen dran', color: 'bg-amber-100 text-amber-800 border-amber-300' };
  }
  return { code: 'puffer', icon: '✅', label: 'Puffer', color: 'bg-emerald-100 text-emerald-800 border-emerald-300' };
}

export interface ScoreBreakdown {
  ueberfaellig: number;
  prioFlag: number;
  terminNaehe: number;
  angefangen: number;
  total: number;
}

export function buildBreakdown(
  lieferdatum: string | null,
  priority: string,
  firstActiveAt: string | null,
  score: number
): ScoreBreakdown {
  const now = Date.now();
  const liefer = lieferdatum ? new Date(lieferdatum + 'T00:00:00').getTime() : null;
  const days = liefer !== null ? Math.floor((liefer - now) / 86400000) : null;
  return {
    ueberfaellig: liefer !== null && liefer < now ? 1000 : 0,
    prioFlag: priority === 'kritisch' ? 500 : priority === 'eilig' ? 200 : 0,
    terminNaehe: days !== null ? Math.max(0, 100 - days * 10) : 0,
    angefangen: firstActiveAt ? 30 : 0,
    total: score,
  };
}

export function breakdownText(b: ScoreBreakdown): string {
  const parts: string[] = [];
  if (b.ueberfaellig) parts.push(`Überfällig +${b.ueberfaellig}`);
  if (b.prioFlag)     parts.push(`Priorität +${b.prioFlag}`);
  if (b.terminNaehe)  parts.push(`Termin-Nähe +${Math.round(b.terminNaehe)}`);
  if (b.angefangen)   parts.push(`Angefangen +${b.angefangen}`);
  return parts.length ? `${parts.join(' · ')} = ${Math.round(b.total)}` : `Score: ${Math.round(b.total)}`;
}
